import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const AllLinkComponent = React.lazy(() => import("../Components/RootComponents/AllLinkComponent"));
const AllLinkPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <AllLinkComponent />
      </Suspense>
    </Fragment>
  );
};

export default AllLinkPage;
